import { render, staticRenderFns } from "./RelatorioDespesas.vue?vue&type=template&id=23c19e90"
import script from "./RelatorioDespesas.vue?vue&type=script&lang=js"
export * from "./RelatorioDespesas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports